import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ResultApi } from '@common/api/result-api';
import { AppConstants } from '@apps/app.constants';
import { BaseListApiService } from '@common/api/base-list-api.service';
import { VeeamJobApi } from '../../models/veeamJob-api';

@Injectable({
    providedIn: 'root'
})
export class VbrJobListApiService extends BaseListApiService<VeeamJobApi>
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.resourceUrl = '/hist/veeam';
    }

    getJobs (qs: string): Observable<ResultApi<VeeamJobApi>>
    {
        return this.getAll(`${this.resourceUrl}/uniquejobs${qs}`);
    }
}
